const styles = {
  unitDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    gap: 2,
  },

  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '28px', sm: '38px' },
    lineHeight: '100%',
    color: '#5236AB',
  },

  versionHistoryContainer: { textAlign: 'left' },
  versionInfoText: { fontSize: 14, color: '#555' },
  versionLink: {
    fontSize: 14,
    cursor: 'pointer',
    color: '#5236AB',
    fontWeight: 'bold',
    '&:hover': { textDecoration: 'underline' },
  },

  grid: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: '95px minmax(0, 1fr)',
    gap: 2,
    minHeight: 0,
    overflow: 'hidden',
  },

  detailCardSmall: {
    gridColumn: 'span 3',
    gridRow: '2',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 0,
    boxShadow: 'none',
    padding: 0.5,      
    height: '100%',
    minHeight: 0,
  },

  detailCardMedium: {
    gridColumn: 'span 9',
    gridRow: '2',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 0,
    boxShadow: 'none',
    padding: 0.5,       
    height: '100%',
    minHeight: 0,
  },

  relatedMetersHeading: {
    fontWeight: 500,
    fontSize: '20px',
    color: '#000',
    mb: 0,
  },

  cardHeaderRow: {
    px: 1.5,
    mt: 0.5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
  },

  cardHeaderRowLeft: {
    px: 1.5,
    mt: 0.5,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
  },

  headerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
  },

  cardContent: {
    p: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    '&:last-child': { pb: 0 },
  },

  emptyStateText: { p: 2, textAlign: 'center' },
};

export default styles;
